import { Component, Input, OnInit } from '@angular/core';
import { IWinningsPerHit } from 'src/app/models/ticket/winningsPerHit.interface';
import { ConstantValues } from 'src/app/models/util/constantValues';

@Component({
  selector: 'app-winnings-per-hit',
  templateUrl: './winnings-per-hit.component.html',
  styleUrls: ['./winnings-per-hit.component.less']
})
export class WinningsPerHitComponent implements OnInit {

  constructor() { }

  @Input()
  possibleWinForNumberOfHits: IWinningsPerHit[];

  public currency = ConstantValues.CURRENCY;


  ngOnInit(): void {
    const a = this.possibleWinForNumberOfHits;

  }

}
